import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ToastsManager } from "ng2-toastr";
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { CommonHelper } from '../../../../shared/helpers/CommonHelper';
import { Company } from '../../../../models/Company.model';
import { CompaniesService } from '../../../../services/companies.service';
import { OwnerService } from '../../../../services/billing-letter/owner.service';
import { Owner } from '../../../../models/billing-letter/Owner.model';
import { AwsService } from '../../../../services/aws.service';
import { ContractTypesEnum } from '../../../../shared/enums/ContractType.enum';
import * as _ from 'lodash';
import { CompanyContract } from '../../../../models/CompanyContract.model';
import { NewContractTypesEnum } from '../../../../shared/enums/ContractType.enum';
import * as moment from 'moment';
import { Industry } from '../../../../models/Industry.model';
import { IndustriesService } from '../../../../services/industries.service';

moment.locale('pt-br');

@Component({
    selector: 'app-company-temporary-create',
    templateUrl: './company-temporary-create.component.html',
    styleUrls: ['./company-temporary-create.component.css']
})
export class CompanyTemporaryCreateComponent implements OnInit {
    @ViewChild('uploadInput') uploadInput:ElementRef;
    @ViewChild('draftContractFile') draftContractUpload:ElementRef;
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    mask = [/[0-3]/, /[0-9]/, '/', /[0-1]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
    loading: boolean;
    companyForm: FormGroup;
    commonHelper: CommonHelper = new CommonHelper();
    company: Company = new Company();
    email: String = '';
    emailFiller: String = '';
    productsCompany: any[] = [];
    managers: Owner[] = [];
    selectedFiles: FileList;
    downloadUrl:string = '';
    selectedDraftContractFile: FileList;
    contractsList = new Array();
    maxFile: Number = 1;
    maxFileSize = 5000000; //5mb
    canPreviewDocument: boolean = false;
    industries: Industry[] = new Array<Industry>();


    contractTypesValid: Boolean = false;
    contractTypes = [];
    readjustmentQuoeficient: any[] = [];
    typeContractModal: string;
    newContractPreview: any;
    contractTypeGroup: any[] = [];
    uploadInputBlocked: boolean = false;
    draftContractFileBlocked: boolean = false;

    constructor(private companiesService: CompaniesService,
        private ownerService: OwnerService,
        private formBuilder: FormBuilder,
        private router: Router,
        private awsService: AwsService,
        private tostr: ToastsManager,
        private industriesService: IndustriesService,
        private contractTypeEnum: ContractTypesEnum,
        private newContractTypeEnum: NewContractTypesEnum) { }

    async ngOnInit() {
        this.loading = true;
        this.companyForm = this.formBuilder.group({
            ownerName: [null, [this.validateSelectOption]],
            manager: [null, [this.validateSelectOption]],
            email: [null, [Validators.required, Validators.email]],
            emailFiller: [null, [Validators.required, Validators.email]],
            industry: [null, [this.validateSelectOptionIndustries]],
        });
        this.managers = await this.ownerService.getActiveUsers();

        this.contractTypes = [ ...this.contractTypeEnum.contractTypes ];
        this.contractTypes.map(ct => ({ ...ct, selected: false }));
        this.industries = await this.industriesService.getAll();
        this.readjustmentQuoeficient = this.commonHelper.getAllReadjustmentQuoeficientGroups();
        this.populateContractTypes();
        this.loading = false;
    }

    async OnSave() {
        try {

            if (this.companyForm.valid) {

                if(!this.productsValid()){
                    this.tostr.warning('Impossível avançar, há campos obrigatórios nos produtos não preenchidos.');
                    return;
                } else if(!this.selectedFiles || this.selectedFiles.length == 0) {
                    this.tostr.warning('O anexo da proposta comercial é obrigatório');
                    return;
                } else {
                    if ((this.selectedFiles && this.selectedFiles.length > this.maxFile) || (this.selectedDraftContractFile && this.selectedDraftContractFile.length > this.maxFile)) {
                        this.tostr.warning('Limite máximo de arquivos atingido, apenas um arquivo pode ser selecionado em cada upload.', 'Upload bloqueado');
                        return;
                    }

                    if (!this.checkLargeFiles()) {
                        this.tostr.warning('Não é permitido upload de arquivos com mais de 5MB', 'Upload bloqueado');
                        return;
                    }
                    this.company.emails = [this.email];

                    const allContractType = this.contractTypes.reduce((acc, { items }) => acc.concat(items), []);
                    this.company.contracts = this.company.contracts.map(contract => {
                        const selectedContract = allContractType.find(c => c.code === contract.contractTypes.code)
                        if(selectedContract) contract.contractTypes.name = selectedContract.name;
                        return contract;
                    });

                    if(this.company.industry._id != '' && this.company.industry._id != undefined)
                    this.company.industry.name = this.industries.find(x => x._id === this.company.industry._id).name;

                    const companyTemporary: any = {
                        ...this.company,
                        emailFiller: this.emailFiller,
                        products: this.productsCompany,
                        contractTypes: this.contractTypes.filter(c => c.selected)
                    }

                    let response = await this.companiesService.createTemporaryCompany(companyTemporary);
                    if (response._id) {
                        this.loading = false;
                        if(this.selectedFiles) {
                            const companyId = response._id;
                            await this.upload(companyId);
                        }

                        this.tostr.success('Um e-mail foi enviado ao cliente para preenchimento dos dados da empresa!', 'Link gerado', { timeOut: 10000 });
                        this.router.navigate(['/companies']);
                    } else {
                        this.loading = false;
                        this.tostr.warning('Erro ao criar registro. Tente novamente!');
                    }
                }
            }
        } catch(err){
            this.loading = false;
            console.log(err);
            this.tostr.warning('Erro ao criar registro. Tente novamente!');
        }
    }

    productsValid(){
        if(this.productsCompany.length > 0){
            for(let prod of this.productsCompany){
                if(prod.name === '' || prod.quantity === 0 || prod.value === 0)
                    return false;
            }
        }
        return true;
    }

    addProduct() {
        this.productsCompany.push({
            name: '',
            quantity: 0,
            value: 0,
            currency: 'dollar',
            monthly: 'true',
            description: ''
        });
    }

    removeProduct(i){
        this.productsCompany.splice(i, 1);
    }

    OnClear() {
        this.company = new Company();
        this.uploadInputBlocked = false;
        this.draftContractFileBlocked  = false;
        this.uploadInput.nativeElement.value = '';
        this.draftContractUpload.nativeElement.value = '';
    }

    verifyValidTouched(fieldName) {
        return !this.companyForm.get(fieldName).valid && this.companyForm.get(fieldName).touched;
    }

    validateSelectOptionIndustries(control: AbstractControl) {
        if (!control.value || control.value == "")
        return {valid: true};

        return null;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    verifyDate(date, field) {
        if (!(new RegExp(this.datePattern).test(date))) {
            this.tostr.warning(`Digite uma data válida.`, "Data inválida!");
            this.company[`${field}`] = "";
        }
    }

    validateSelectOption(control: AbstractControl) {
        if (control.value == 0 || control.value == '0' ||
            control.value == 'undefined' || control.value == undefined)
            return {valid: true};
        return null;
    }

    selectFile(event, fileType: any | string) {
        this.selectedFiles = event.target.files as FileList;
        const fileAlreadyExists = this.contractsList.find(file => file.contract === 'Proposta Comercial');
        if (!fileAlreadyExists) {
            this.uploadInputBlocked = true
            this.contractsList = [
                ...this.contractsList,
                {
                    fileName: this.selectedFiles[0]['name'],
                    lastModified: this.selectedFiles[0]['lastModified'],
                    contract: fileType
                }
            ];
            return;
        }
    }

    selectDraftContractFile(event, fileType: any | string): void {
        this.selectedDraftContractFile = event.target.files as FileList;
        const fileAlreadyExists = this.contractsList.find(file => file.contract === 'Minuta de Contrato');
        if (!fileAlreadyExists) {
            this.draftContractFileBlocked  = true;
            this.contractsList = [
                ...this.contractsList,
                {
                    fileName: this.selectedDraftContractFile[0]['name'],
                    lastModified: this.selectedDraftContractFile[0]['lastModified'],
                    contract: fileType
                }
            ];
        }
    }

    async upload(id) {
        if(this.selectedFiles){
            const file = this.selectedFiles.item(0);
            const renamedFile = new File(
                [file],
                'proposta_comercial.pdf',
                { type: 'application/pdf' }
            );
            await this.awsService.uploadfile(
                renamedFile,
                `company-temporary/${id}`
            );
        }
        if(this.selectedDraftContractFile){
            const file = this.selectedDraftContractFile.item(0);
            const renamedFile = new File(
                [file],
                `minuta_contrato.pdf`,
                { type: 'application/pdf'}
            );
            await this.awsService.uploadfile(
                renamedFile,
                `company-temporary/${id}`
            );
        }
    }

    addContractCompany() {
        const contracts = [...this.company.contracts];
        const newContract: CompanyContract = new CompanyContract();
        this.company.contracts = [
            ...contracts,
            newContract
        ];
    }

    removeContract(i) {
        this.company.contracts.splice(i, 1);
        this.newContractPreview.splice(i, 1);
    }

    populateContractTypes() {
        this.contractTypes = [...this.newContractTypeEnum.contractTypes];
    }

    validateCompanyContract() {
        if(this.company.contracts.length == 0) return false;
        for(let contract of this.company.contracts) {
            if(contract.contractTypes.code == 0 || contract.contractTypes.code == null
            || contract.contractStart == undefined || contract.contractStart == 'undefined'
            || contract.contractEnd == undefined || contract.contractEnd == 'undefined'
            || contract.readjustmentNotification == undefined || contract.readjustmentNotification == null
            || contract.readjustmentQuoeficient == 0 || contract.readjustmentQuoeficient == null) {
                return false;
            }
        }
        return true;
    }

    deleteFile(indexFile: number): void {
        const file = {...this.contractsList[indexFile]};
        this.contractsList.splice(indexFile, 1);

        if (file.contract == "Proposta Comercial") {
            this.selectedFiles = null;
            this.uploadInputBlocked = false;
            this.uploadInput.nativeElement.value = '';
        } else {
            this.selectedDraftContractFile = null;
            this.draftContractFileBlocked = false;
            this.draftContractUpload.nativeElement.value = '';
        }
    }

    checkLargeFiles(): boolean {
        if(this.selectedFiles) {
            for(let i = 0;i<this.selectedFiles.length;i++) {
                const file = this.selectedFiles.item(i);
                if (file.size > this.maxFileSize) {
                    return false;
                }
            }
        }

        if (this.selectedDraftContractFile) {
            for(let i = 0; i<this.selectedDraftContractFile.length;i++) {
                const file = this.selectedDraftContractFile.item(i);
                if (file.size > this.maxFileSize) {
                    return false;
                }
            }
        }
        return true;
    }

    async downloadPreview(event: any) {
        this.downloadUrl = await this.awsService.download(event);
    }

    async openModalContract(event: any) {
        if (!this.documentPreviewFields) {
            return;
        }
        this.typeContractModal = event;
    }
    documentPreviewFields() {
        if(!this.company.companyName || !this.company.address.street
        || !this.company.address.number || !this.company.address.complement
        || !this.company.address.district || !this.company.cnpj || !this.company.contracts) {
            return false;
        }
        return true;
    }

      verifyFieldsForDocumentPreview(doc?: CompanyContract) {
           if (this.documentPreviewFields()) {
              this.canPreviewDocument = true;
          } else {
              this.tostr.warning('Há dados obrigatórios no documento ClickSign que não foram preenchidos na empresa antes de gerar o preview. Verifique os campos: Nome Fantasia, Razão Social e os campos de endereço do cliente.',
              'Formulário incompleto', {timeout: 5000});
              this.canPreviewDocument = false;
          }
      }

      populateContractTypesSection() {
          const contracts = [...this.company.contracts];
          this.newContractPreview = [
              ...contracts,
          ];
      }

      newSelectedContract(doc?: any, index?: any){
          const allContractsTypes = this.contractTypes.reduce((acc, { items }) => acc.concat(items), []);
          const contractType = allContractsTypes.find(c => c.code === doc.contractTypes.code);
          if(contractType) doc.contractTypes.name = contractType.name;

          doc.isNew = true;
          this.newContractPreview[index] = doc;
      }

      onContractChange(){
        let selectedContractType = this.contractTypes.find( c => c.items.find(i => i.code == this.company.contracts[0].contractTypes.code));
        this.contractTypeGroup = selectedContractType.companyContractType;
      }

      generateCompanyContract(){
        let selectedCompanyContractType = this.contractTypeGroup
        this.openModalContract(selectedCompanyContractType)
      }
}



// WEBPACK FOOTER //
// ./src/app/views/companies/company-temporary/company-temporary-create/company-temporary-create.component.ts